/**

Coded by www.techhighway.ca

*/

import { Link, useLocation } from "react-router-dom";

// Material Dashboard 2 React components
import Icon from "@mui/material/Icon";
import CallType, { NA, Status } from "components/Icon/Call";
import customAlert from "components/MDAlert/customAlert";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { PreserveTable } from "context";
import { useContext, useEffect, useState } from "react";
import CallsService from "services/call-service";
import authPermission from "utility/auth-permissions";
import { convertSecondsToTime, formatDateTime, formatPhone } from "utility/helpers";
export default function data(props) {
  const { hasPermission } = authPermission();
  const pagePermission = hasPermission("/manage-calls");
  const preserveTable = useContext(PreserveTable);
  const { page_no, page_size, sort_column, sort_column_value, search_value } =
    preserveTable?.parameter;
  const { openAlertSB, closeAlertSB, renderAlertSB } = customAlert();
  const [callsData, setCallsData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [isData, setIsData] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location?.state?.color) {
      openAlertSB(location?.state);
      setTimeout(function () {
        closeAlertSB();
      }, 3000);
    }
  }, []);

  const getData = async (page_no, page_size, sortColumn, sortColumnValue, searchWord) => {
    const preserveData = {
      page_no,
      page_size,
      sort_column: sortColumn,
      sort_column_value: sortColumnValue,
      search_value: searchWord,
    };
    preserveTable.setPreserveCall(preserveData);
    const response = await CallsService.getCalls(
      page_no,
      page_size,
      sortColumn,
      sortColumnValue,
      searchWord
    );
    setCallsData(response?.data);
    setTotalData(response?.total);
    setIsData(true);
  };

  const allRows = [];
  callsData?.map((record, index) => {
    const eachData = {
      id: (
        <MDTypography
          component={Link}
          to={pagePermission.edit ? `/manage-calls/edit?id=${record.id}` : ""}
          variant="body2"
          color="text"
        >
          {record.id}
        </MDTypography>
      ),
      agent: (
        <MDTypography color="info" component={Link} to={`/manage-agents/edit?id=${record.agent?.id}`} display="block" variant="body2">
          {record.agent.name} (#{record.agent.id})
        </MDTypography>
      ),
      agent_phone: (
        <MDTypography display="block" variant="body2">
          {formatPhone(record.agent_phone) || <NA />}
        </MDTypography>
      ),
      customer_phone: (
        <MDTypography display="block" variant="body2">
          <CallType type={record.call_type} value={formatPhone(record.customer_phone)} />
        </MDTypography>
      ),
      end_reason: (
        <MDTypography display="block" variant="body2">
          <Status value={record.end_reason} />
        </MDTypography>
      ),
      failed: (
        <>
          {/* {record.failed === -1 ? (
            <NA />
          ) : (
            <MDTypography
              display="block"
              variant="body2"
              color={record.failed ? "error" : "success"}
            >
              {record.failed ? "Fail" : "Pass"}
            </MDTypography>
          )} */}
          <Status
            value={record.failed === -1 ? (record.end_reason ? "N/A" : "Call In Progress") : record.failed ? "Fail" : "Pass"}
          />
        </>
      ),
      started_at: (
        <MDTypography display="block" variant="body2" sx={{ whiteSpace: 'nowrap' }}>
          {formatDateTime(record.started_at)}
        </MDTypography>
      ),
      duration: (
        <MDTypography display="block" variant="body2">
          {convertSecondsToTime(record.duration)}
        </MDTypography>
      ),
      action: (
        <MDBox display="flex">
          {pagePermission.edit ? (
            <MDTypography
              mr={1}
              mt={1}
              component={Link}
              to={`/manage-calls/edit?id=${record.id}`}
              title="View Call Details"
              display="block"
              variant="body2"
              color="info"
            >
              <Icon fontSize="small">preview</Icon>
            </MDTypography>
          ) : (
            ""
          )}
        </MDBox>
      ),
    };
    allRows[index] = eachData;
  });

  return {
    columns: [
      { Header: "Id", accessor: "id", width: "5%", align: "left" },
      { Header: "Agent", accessor: "agent", align: "left" },
      { Header: "Agent Phone", accessor: "agent_phone", align: "left" },
      { Header: "Customer Phone", accessor: "customer_phone", align: "left" },
      { Header: "Start Time", accessor: "started_at", align: "left" },
      { Header: "Duration", accessor: "duration", width: "50px", align: "left" },
      { Header: "Ended Reason", accessor: "end_reason", align: "left" },
      { Header: "Success?", accessor: "failed", width: "50px", align: "left" },
      ...(pagePermission.edit
        ? [{ Header: "actions", accessor: "action", width: "1%", align: "center" }]
        : []),
    ],
    rows: allRows,
    totalData,
    page: page_no,
    pageSize: page_size,
    getData,
    sortColumn: sort_column,
    sortColumnValue: sort_column_value,
    searchValue: search_value,
    pagePermission,
    isData: isData,
  };
}
